import { useCallback, useState } from 'react';
import { MAX_PLANNED_VIRTUAL_APPOINTMENTS } from '../../services/virtualAppointments';
import { createOpenNowDraft, type OpenNowDraft, type OpenNowDraftPatch } from './openNowDraft';

export interface OpenNowDrafts {
    drafts: OpenNowDraft[];
    /** The new draft's key, or null at the cap. */
    add: () => string | null;
    update: (key: string, patch: OpenNowDraftPatch) => void;
    remove: (key: string) => void;
}

// Starts empty so staff add each VA deliberately.
export function useOpenNowDrafts(): OpenNowDrafts {
    const [drafts, setDrafts] = useState<OpenNowDraft[]>([]);
    const add = useCallback((): string | null => {
        if (drafts.length >= MAX_PLANNED_VIRTUAL_APPOINTMENTS) return null;
        const draft = createOpenNowDraft();
        setDrafts((prev) => [...prev, draft]);
        return draft.key;
    }, [drafts.length]);
    const update = useCallback(
        (key: string, patch: OpenNowDraftPatch) =>
            setDrafts((prev) => prev.map((d) => (d.key === key ? { ...d, ...patch } : d))),
        []
    );
    const remove = useCallback(
        (key: string) => setDrafts((prev) => prev.filter((d) => d.key !== key)),
        []
    );
    return { drafts, add, update, remove };
}
